// extracted by mini-css-extract-plugin
export default {"card":"Styles_card__86JSC","subcontainer1":"Styles_subcontainer1__AaWce"};